var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "complaint-work-order" }, [
        _c("div", { staticStyle: { color: "#409eff" } }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("collectionCenter.reportingBranch")) + "："),
          ]),
          _c("span", { staticStyle: { "margin-right": "50px" } }, [
            _vm._v(_vm._s(_vm.replyMessageData.reportSiteName)),
          ]),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("customerManagements.varianceNumber")) + "："),
          ]),
          _c("span", { staticStyle: { "margin-right": "50px" } }, [
            _vm._v(_vm._s(_vm.replyMessageData.detailSum)),
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Deadline")) + "：")]),
          _c("span", [_vm._v(_vm._s(_vm.replyMessageData.deadlineTime))]),
        ]),
        _c(
          "div",
          { ref: "messageListRef", staticClass: "message-content-bg" },
          _vm._l(_vm.messageDetail, function (item, index) {
            return _c("div", { key: index }, [
              item.createUser !== _vm.currentId
                ? _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                    _c("div", { staticStyle: { "text-align": "left" } }, [
                      _c("div", [
                        item.type === 1
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.cs, alt: "cs" },
                            })
                          : item.type === 3
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.dc, alt: "dc" },
                            })
                          : _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.aj, alt: "aj" },
                            }),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "-60px",
                            "margin-left": "60px",
                          },
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              {
                                style: {
                                  color:
                                    item.type === 2 ? "#ffb907" : "#409eff",
                                },
                              },
                              [_vm._v(_vm._s(item.replyPersonName))]
                            ),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v(_vm._s(item.createTime))]
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "complaint-work-order-message-content",
                                staticStyle: { "word-break": "break-all" },
                                style: {
                                  float: "left",
                                  backgroundColor:
                                    item.type === 2 ? "#f6f0df" : "#ffffff",
                                },
                              },
                              [
                                _c("div", {
                                  staticStyle: { "text-align": "left" },
                                  domProps: {
                                    innerHTML: _vm._s(item.replyContent),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.getImgSrc($event)
                                    },
                                  },
                                }),
                                item.mediaUrl
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      _vm._l(item.urlArr, function (list, ind) {
                                        return _c(
                                          "div",
                                          {
                                            key: ind,
                                            staticClass: "complaint-work-file",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getImgSrcFile(
                                                  list.url
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(list.name) + " "
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c("div", { staticStyle: { clear: "both" } }),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                    _c("div", { staticStyle: { "text-align": "right" } }, [
                      _c("div", [
                        item.type === 1
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.cs, alt: "cs" },
                            })
                          : item.type === 3
                          ? _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.dc, alt: "dc" },
                            })
                          : _c("img", {
                              staticClass: "img",
                              staticStyle: { width: "50px !important" },
                              attrs: { src: _vm.aj, alt: "aj" },
                            }),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "-60px",
                            "margin-right": "60px",
                          },
                        },
                        [
                          _c("div", [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [_vm._v(_vm._s(item.createTime))]
                            ),
                            _c(
                              "span",
                              {
                                style: {
                                  color:
                                    item.type === 2 ? "#ffb907" : "#409eff",
                                },
                              },
                              [_vm._v(_vm._s(item.replyPersonName))]
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "complaint-work-order-message-content",
                                staticStyle: {
                                  float: "right",
                                  "background-color": "#c6e6f4",
                                  "word-break": "break-all",
                                },
                              },
                              [
                                _c("div", {
                                  staticStyle: { "text-align": "right" },
                                  domProps: {
                                    innerHTML: _vm._s(item.replyContent),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.getImgSrc($event)
                                    },
                                  },
                                }),
                                item.mediaUrl
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      _vm._l(item.urlArr, function (list, ind) {
                                        return _c(
                                          "div",
                                          {
                                            key: ind,
                                            staticClass: "complaint-work-file",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getImgSrcFile(
                                                  list.url
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(list.name) + " "
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c("div", { staticStyle: { clear: "both" } }),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
            ])
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticStyle: { padding: "10px" } },
        [
          _c("tinymce", {
            attrs: {
              height: 180,
              "msg-plugin": _vm.msgPlugin,
              placeholder: _vm.$t("GlobalSetObj.pleaseInputContent") + "...",
              toolbar: _vm.toolbar,
              "is-image": true,
            },
            model: {
              value: _vm.textarea,
              callback: function ($$v) {
                _vm.textarea = $$v
              },
              expression: "textarea",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "10px", "text-align": "right" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.submitMsg },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Reply")) + " ")]
          ),
        ],
        1
      ),
      _vm.showViewer
        ? _c("el-image-viewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": _vm.imgArr },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }